import { Component, input, output, computed, ChangeDetectionStrategy } from '@angular/core';

import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';

export interface HomeBannerSlide {
  id: string;
  kicker?: string;
  kickerIcon?: string;
  title: string;
  subtitle: string;
  ctaLabel: string;
  ctaLink?: string;
  accent: string;
  image: string;
  imageAlt: string;
  imagePosition?: string;
}

@Component({
  selector: 'app-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.scss'],
  imports: [CarouselModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeBannerComponent {
  slides = input<readonly HomeBannerSlide[]>([]);

  ctaClick = output<HomeBannerSlide>();

  protected readonly slideList = computed(() => [...this.slides()]);
}
